import clsx from 'clsx';
import React, { FC } from 'react';

interface AppointmentSummaryDetailsProps {
  title: string;
  content: string;
  shouldHide?: boolean;
  testKey?: string;
  className?: string;
}

export const AppointmentSummaryDetails: FC<AppointmentSummaryDetailsProps> = ({
  title,
  content,
  testKey,
  className,
  shouldHide = true,
}) => {
  return (
    <div
      className={clsx(
        'mb-6 gap-3 desktop:flex desktop:flex-col desktop:items-start desktop:gap-0',
        shouldHide && 'hidden',
        className,
      )}
    >
      <h3 className={'text-body-medium-semibold'}>{title}</h3>
      <p
        data-testid={`appointment-${
          testKey ?? title.replace(/\s+/g, '').toLowerCase()
        }`}
        className={'content text-body-medium'}
      >
        {content}
      </p>
    </div>
  );
};
